var App = {
    floatPosition: 0,
    $toTopButton: $('[data-toggle="to-top"]'),
    $MemberMenuButton: $('[data-toggle="member-menu-toggle"]'),
    $MemberPopup: $('[data-popup="member-box"]'),
    isMemberMenuOpened: false,
    init: function () {
        this.initToTopButton();
        this.initMemberMenuButton();
        this.initAllMenu();
        this.initPopupToggle();
        this.initJsLettering();
        this.initFloatMenu();
        this.initCheckboxAll();
        this.initTab();
        this.initServiceTab();

        $(document).on('click', '.kisec-service .review-list .list [data-toggle="more"]', function (e) {
            e.preventDefault();
            $(this).parents('li').toggleClass('opened');
            $(this).find('i').toggleClass('fa-plus fa-minus');
        });
        $(window).resize(function () {
            if ($(window).width() < 1322) {

                if ($('.sub-navs').length > 0) {
                    var offsetX = $('.sub-navs li.active').offset().left;
                    $('.sub-navs').animate({
                        scrollLeft: offsetX
                    })
                }
            }
        }).resize();
    }
};

App.initTab = function () {
    $('[data-component="tab"]').each(function () {
        var $tab = $(this);
        $('[data-toggle="tab-toggler"] a', $tab).click(function (e) {
            e.preventDefault();

            $('[data-toggle="tab-toggler"]').removeClass('active');
            $('[data-toggle="tab-panel"]').removeClass('active');
            $(this).parents('li').addClass('active');
            var target = $(this).attr('href');
            $(target).addClass('active');
        });
    })
};

App.ServiceTabOffset = 0;
App.initServiceTab = function () {
    if ($('.kisec-service .tab').length > 0) {
        var $tab = $('.kisec-service .tab');
        App.ServiceTabOffset = $tab.offset().top;

        $(window).resize(function () {
            $('.kisec-service').removeClass('tab-fixed');
            App.ServiceTabOffset = $tab.offset().top;
        });

        $(window).scroll(function () {
            if ($(window).scrollTop() + $tab.height() >= App.ServiceTabOffset) {
                $('.kisec-service').addClass('tab-fixed');
            } else {
                $('.kisec-service').removeClass('tab-fixed');
            }

            var ids = [];
            $tab.find('li a').each(function () {
                ids.push($(this).attr('href'));
            });

            $tab.find('li').removeClass('active');
            var addOffset = $('.kisec-service > .tab-container').outerHeight(true);

            ids.forEach(function (id) {
                if ($(id).offset().top - addOffset - $('header.k-header').height() < $(window).scrollTop()) {
                    $tab.find('li a[href="' + id + '"]').parents('li').addClass('active').siblings().removeClass('active');
                }
            })
        }).scroll();

        $('.kisec-service .tab ul li a').click(function (e) {
            e.preventDefault();
            var href = $(this).attr('href'),
                offsetTop = $(href).offset().top;

            var addOffset = 0;
            if (!$('.kisec-service').hasClass('tab-fixed')) {
                addOffset = $('.kisec-service > .tab-container').outerHeight(true);
            }

            $('html,body').animate({
                scrollTop: offsetTop - $('header.k-header').height() - addOffset
            }, 0);

            //$(window).scroll();
        });
    }
}


/**
 * 페이지의 지정한 위치로 이동한다.
 * @param offset    이동할 위치 (default: 0)
 * @param animationTime 이동 시간 (default:300 ms)
 */
App.animateToOffset = function (offset, animationTime) {
    animationTime = typeof animationTime != 'undefined' && animationTime ? animationTime : 300;
    offset = typeof offset != 'undefined' && offset ? offset : 0;
    $('html,body').animate({
        scrollTop: offset
    }, animationTime);
};

/**
 * 현재 페이지의 스크롤 위치에 따라 상단으로 이동버튼을 열고 감춘다.
 */
App.displayToTopButton = function () {
    if ($(window).scrollTop() > $(window).height() / 2) {
        App.$toTopButton.fadeIn('fast');
    } else {
        App.$toTopButton.fadeOut('fast');
    }
};

/**
 * 상단으로 이동 버튼에대한 이벤트나 매서드를 초기화한다.
 */
App.initToTopButton = function () {
    $(window).scroll(this.displayToTopButton).scroll();
    $('[data-toggle="to-top"]').click(function (e) {
        e.preventDefault();
        App.animateToOffset(0, 300);
    });
};

/**
 * 전체 메뉴 버튼에 대한 이벤트를 초기화한다.
 */
App.initMemberMenuButton = function () {
    this.$MemberMenuButton.click(function (e) {
        e.preventDefault();

        App.$MemberPopup.slideToggle('fast');
        App.$MemberMenuButton.find('i').toggleClass('fa-times fas podo-icon user');
    })
};

App.initAllMenu = function () {
    $('#nav .main-navigation > li').mouseover(function () {
        $('body, .menu-mask').addClass('menu-opened');
    });
    $('.hrpool-header').mouseleave(function () {
        $('body, .menu-mask').removeClass('menu-opened');
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            $('body').addClass('sticky');
        } else {
            $('body').removeClass('sticky');
        }
    }).scroll();
};

App.initPopupToggle = function () {
    $(document).on('click', '[data-toggle="popup"]', function (e) {
        e.preventDefault();

        var target = $(this).data('target'),
            $popup = $('[data-popup="' + target + '"]');

        if ($popup.length <= 0) return;

        $popup.toggleClass('opened');
    });
};

// 글자를 쪼개주는 plugin
App.initJsLettering = function () {
    if (typeof $.fn.lettering !== 'undefined') {
        $('.js-lettering').lettering('letters').children().addClass('char');
    }
};

App.initFloatMenu = function () {
    if ($('body.kisec').length > 0) {
        App.floatPosition = 55;

        App.floatPosition += ($('.k-contents-top').length > 0) ? $('.k-contents-top').height() : 100;

        $(window).scroll(function (e) {
            var footerPosition = $(".k-footer").length > 0 ? $(".k-footer").offset().top : $('body').height(),
                floatingHeight = $('.quick-right').height(),
                scrollTop = $(window).scrollTop(),
                newPosition = (scrollTop > App.floatPosition) ? scrollTop + 140 : App.floatPosition;

            if (newPosition + floatingHeight >= parseInt(footerPosition)) {
                newPosition = footerPosition - floatingHeight;
            }

            if (newPosition < App.floatPosition) {
                newPosition = App.floatPosition;
            }

            $('.quick-right').stop().animate({
                top: newPosition + 'px',
            }, 200);
        }).scroll();
    }

};

App.initCheckboxAll = function () {
    var checkboxs = document.querySelectorAll('[data-checkbox]');
    if (checkboxs.length > 0) {
        for (var i = 0; i < checkboxs.length; i++) {
            checkboxs[i].addEventListener('change', function (event) {
                var $check = this,
                    is_all = this.getAttribute('data-checkbox-all') != null ? true : false,
                    name = this.getAttribute('data-checkbox'),
                    checked = this.checked,
                    $allCheck = is_all ? $check : (document.querySelectorAll('[data-checkbox="' + name + '"][data-checkbox-all]').length > 0 ? document.querySelectorAll('[data-checkbox="' + name + '"][data-checkbox-all]')[0] : null),
                    checks = document.querySelectorAll('[data-checkbox="' + name + '"]');

                if (!$allCheck) return;

                if (is_all) {
                    for (var k = 0; k < checks.length; k++) {
                        checks[k].checked = checked;
                    }
                } else {
                    var is_all_check = true;
                    for (var k = 0; k < checks.length; k++) {
                        if (checks[k].getAttribute('data-checkbox-all') != null) continue;
                        if (checks[k].checked == false) {
                            is_all_check = false;
                            break;
                        }
                    }
                    $allCheck.checked = is_all_check;
                }
            });
        }
    }
};

var getAverage = function (elements, number) {
    var sum = 0;

    var lastElements = elements.slice(Math.max(elements.length - number, 1));

    for (var i = 0; i < lastElements.length; i++) {
        sum = sum + lastElements[i];
    }

    return Math.ceil(sum / number);
}


$(function () {
    App.init();
});